export default __webpack_public_path__ + "static/media/wallet.io.1ae44647.jpeg";